import { TRADABLES_TYPE } from "@helpers/constants";
import { Stock as OldStock } from "@models/derivative/currencies/stock";
import { Tradable, TradableAdapter } from "../tradable";

export interface Stock extends Tradable {
	isin: string;
}

export class StockAdapter extends TradableAdapter {
	public adapt(stock: OldStock): Stock {
		const tradable = super.adapt(stock);
		return {
			...tradable,
			isin: stock.getIsin(),
			type: TRADABLES_TYPE.STOCK
		};
	}
}
